function syncLayoutButtons() {
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;
  let selected = container.classList.contains('product-list') ? 'listv' : container.classList.contains('product-gallery') ? 'galleryv' : 'gridv';
  if (window.innerWidth < 992 && selected === 'galleryv') selected = 'gridv';
  document.querySelectorAll('.wblistgridbtn').forEach(button => {
    button.setAttribute('aria-pressed', String(button.classList.contains(selected)));
  });
}
function layoutSwitcher() {
  document.querySelectorAll('.wblistgridbtn').forEach(button => {
    button.removeEventListener('click', toggle);
    button.addEventListener('click', toggle);
  });
  syncLayoutButtons();
}
function toggle(event) {
  const button = event.currentTarget;
  const container = document.getElementById('ProductGridContainer');
  if (!container) return;
  const selected = button.classList.contains('listv') ? 'listv' : button.classList.contains('galleryv') ? 'galleryv' : 'gridv';
  document.querySelectorAll('.wblistgridbtn').forEach(control => {
    control.classList.toggle('active', control.classList.contains(selected));
    control.classList.remove('active_mobile');
  });
  container.classList.remove('product-list', 'product-grid', 'product-gallery');
  container.classList.add(selected === 'listv' ? 'product-list' : selected === 'galleryv' ? 'product-gallery' : 'product-grid');
  const grid = document.getElementById('product-grid');
  if (grid && selected !== 'listv') grid.classList.remove('product-list');
  syncLayoutButtons();
}
document.addEventListener('shopify:section:load', layoutSwitcher);
window.addEventListener('resize', syncLayoutButtons);
layoutSwitcher();

// on scroll play video
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', videoScroll);
function videoScroll() {
  if ( document.querySelectorAll('video[autoplay]').length > 0) {
    var windowHeight = window.innerHeight, videoEl = document.querySelectorAll('video[autoplay]');
    for (var i = 0; i < videoEl.length; i++) {
      var thisVideoEl = videoEl[i],
          videoHeight = thisVideoEl.clientHeight,
          videoClientRect = thisVideoEl.getBoundingClientRect().top;
      if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
        thisVideoEl.play();
      } else {
        thisVideoEl.pause();
      }
    }
  }
}

// timer
setInterval(countDown, 1000);
function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date').replaceAll('-','/')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}